interface AuthConfig {
    authority: string;
    tokenEndpoint: string;
    clientId: string;
    clientSecret: string;
    scope: string;
}

interface Config {
    actingTenant: string;
    apiBaseUrl: string;
    auth: AuthConfig;
}

export const config: Config = {
    // No backend reads X-Tenant-ID; the MaaS tenant is MAAS_TENANT_CODE on the backend.
    actingTenant: import.meta.env.VITE_TENANT || '',
    apiBaseUrl: '',  // Empty string uses relative URLs that go through Next.js API proxy
    auth: {
        authority: import.meta.env.VITE_OAUTH_AUTHORITY || 'http://localhost:5080',
        tokenEndpoint: '/connect/token',
        // Beim Produkt-Rebranding zu GridPilot bewusst NICHT umbenannt: 'netzcockpit' ist die bei
        // MaaS/Keycloak registrierte Client-Identität. Eine Umbenennung bricht den Login aller Instanzen.
        clientId: import.meta.env.VITE_OAUTH_CLIENT_ID || 'netzcockpit',
        clientSecret: import.meta.env.VITE_OAUTH_CLIENT_SECRET || 'netzcockpit-client-secret',
        scope: 'openid profile email maas.api offline_access'
    }
};
